import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';

import BasicButton from '@/ui-components/BasicButton.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOfferBell',
  props: {
    hasText: { type: Boolean, default: true },
    isTitleInWatchlist: { type: Boolean },
    inline: { type: Boolean },
    compact: { type: Boolean },
    additionalContexts: { default: () => [] }
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'onNotifyMe'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { hasText: boolean, isTitleInWatchlist?: boolean, inline?: boolean, compact?: boolean, additionalContexts: SnowplowContext[] };





function onNotifyMe() {
	emits('onNotifyMe');

	if (props.isTitleInWatchlist) return;
	TrackingHelper.trackEvent('userinteraction', { action: 'notify_me_clicked' }, props.additionalContexts);
}

return { __sfc: true,props, emits, onNotifyMe, BasicButton, faBell, jwCheckIcon }
}

})